import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-4 mb-8 container", style: _vm.cssVars },
    [
      _c(
        VBreadcrumbs,
        { staticClass: "d-print-none" },
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v("Home")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            { attrs: { to: { name: "genericQrPrint", params: {} } } },
            [_vm._v(" Generic QR Code Print ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-print-none" },
        [
          _c(VTextarea, {
            attrs: {
              outlined: "",
              label: "Labels Input",
              hint: 'Each line: serial,label (quote fields if they contain commas, e.g., "ABC","DEF,GHI")',
              rows: "5",
            },
            model: {
              value: _vm.inputText,
              callback: function ($$v) {
                _vm.inputText = $$v
              },
              expression: "inputText",
            },
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-center" },
            [
              _c(VTextField, {
                staticClass: "mx-2 flex-grow-1",
                attrs: {
                  outlined: "",
                  dense: "",
                  label: "Filter entries",
                  hint: "Example: 1, 2, 5 - 10",
                },
                model: {
                  value: _vm.filterTerm,
                  callback: function ($$v) {
                    _vm.filterTerm = $$v
                  },
                  expression: "filterTerm",
                },
              }),
              _c(VTextField, {
                staticClass: "mx-2 flex-grow-0",
                attrs: {
                  outlined: "",
                  dense: "",
                  label: "Empty Padding",
                  type: "number",
                },
                model: {
                  value: _vm.emptyPadding,
                  callback: function ($$v) {
                    _vm.emptyPadding = _vm._n($$v)
                  },
                  expression: "emptyPadding",
                },
              }),
              _c(
                VBtn,
                {
                  staticClass: "mx-2",
                  on: {
                    click: function ($event) {
                      return _vm.print()
                    },
                  },
                },
                [_vm._v("Print")]
              ),
            ],
            1
          ),
          _c(
            VExpansionPanels,
            { staticClass: "mb-5" },
            [
              _c(
                VExpansionPanel,
                [
                  _c(VExpansionPanelHeader, [
                    _vm._v("Advanced Print Settings"),
                  ]),
                  _c(
                    VExpansionPanelContent,
                    [
                      _c("page-params", {
                        attrs: {
                          pageName: "genericQrPrint",
                          vuexName: "qrPrintParameters",
                          parameters: _vm.settings,
                        },
                      }),
                      _c(VDivider),
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c(VTextField, {
                              staticClass: "mx-2",
                              attrs: {
                                label: "Brand Name",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.parameters.brandName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.parameters, "brandName", $$v)
                                },
                                expression: "parameters.brandName",
                              },
                            }),
                            _c(
                              VBtn,
                              {
                                staticClass: "ml-2",
                                on: {
                                  click: function ($event) {
                                    return _vm.addStickerField()
                                  },
                                },
                              },
                              [_vm._v("Add Field")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._l(
                        _vm.parameters.optionalFields,
                        function (field, index) {
                          return _c("div", { key: index }, [
                            _c(
                              "div",
                              { staticClass: "d-flex" },
                              [
                                _c(VTextField, {
                                  staticClass: "mx-2",
                                  attrs: {
                                    label: "Field Label",
                                    outlined: "",
                                    dense: "",
                                  },
                                  model: {
                                    value: field.label,
                                    callback: function ($$v) {
                                      _vm.$set(field, "label", $$v)
                                    },
                                    expression: "field.label",
                                  },
                                }),
                                _c(VTextField, {
                                  staticClass: "mx-2",
                                  attrs: {
                                    label: "Field Value",
                                    outlined: "",
                                    dense: "",
                                  },
                                  model: {
                                    value: field.value,
                                    callback: function ($$v) {
                                      _vm.$set(field, "value", $$v)
                                    },
                                    expression: "field.value",
                                  },
                                }),
                                _c(
                                  VBtn,
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteField(index)
                                      },
                                    },
                                  },
                                  [
                                    _c(VIcon, [
                                      _vm._v("mdi-delete-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                      _c(
                        VRadioGroup,
                        {
                          attrs: { row: "", label: "Code Type:" },
                          model: {
                            value: _vm.parameters.codeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.parameters, "codeType", $$v)
                            },
                            expression: "parameters.codeType",
                          },
                        },
                        [
                          _c(VRadio, {
                            attrs: { label: "QR", value: "qr" },
                          }),
                          _c(VRadio, {
                            attrs: { label: "Barcode", value: "barcode" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "px",
                              outlined: "",
                              dense: "",
                              label: "Left",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.left,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "left", $$v)
                              },
                              expression: "parameters.left",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "px",
                              outlined: "",
                              dense: "",
                              label: "Top",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.top,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "top", $$v)
                              },
                              expression: "parameters.top",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "px",
                              outlined: "",
                              dense: "",
                              label: "Right",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.right,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "right", $$v)
                              },
                              expression: "parameters.right",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "px",
                              outlined: "",
                              dense: "",
                              label: "Bottom",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.bottom,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "bottom", $$v)
                              },
                              expression: "parameters.bottom",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "pt",
                              outlined: "",
                              dense: "",
                              label: "Font Size",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.fontSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "fontSize", $$v)
                              },
                              expression: "parameters.fontSize",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "pt",
                              outlined: "",
                              dense: "",
                              label: "Header Font Size",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.headerFontSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "headerFontSize", $$v)
                              },
                              expression: "parameters.headerFontSize",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "pt",
                              outlined: "",
                              dense: "",
                              label: "Footer Font Size",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.footerFontSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "footerFontSize", $$v)
                              },
                              expression: "parameters.footerFontSize",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "pt",
                              outlined: "",
                              dense: "",
                              label:
                                _vm.parameters.codeType === "qr"
                                  ? "QR Code Size"
                                  : "Barcode Height",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.qrSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "qrSize", $$v)
                              },
                              expression: "parameters.qrSize",
                            },
                          }),
                          _vm.parameters.codeType === "barcode"
                            ? _c(VTextField, {
                                staticClass: "mx-2",
                                attrs: {
                                  suffix: "px",
                                  outlined: "",
                                  dense: "",
                                  label: "Barcode Bar Width",
                                  type: "number",
                                },
                                model: {
                                  value: _vm.parameters.barcodeBarWidth,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.parameters,
                                      "barcodeBarWidth",
                                      $$v
                                    )
                                  },
                                  expression: "parameters.barcodeBarWidth",
                                },
                              })
                            : _vm._e(),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "cols",
                              outlined: "",
                              dense: "",
                              label: "Number of Columns",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.cols,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "cols", $$v)
                              },
                              expression: "parameters.cols",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(VDivider, { staticClass: "mb-5" }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "sticker-container",
          style: { "--cols": _vm.parameters.cols },
        },
        _vm._l(_vm.rows, function (rowEntries, rowIndex) {
          return _c(
            "div",
            { key: rowIndex, staticClass: "sticker-row" },
            _vm._l(rowEntries, function (entry, colIndex) {
              return _c(
                "div",
                {
                  key: entry.id,
                  staticClass: "sticker",
                  style: {
                    paddingTop: _vm.parameters.top + "px",
                    paddingRight: _vm.parameters.right + "px",
                    paddingBottom: _vm.parameters.bottom + "px",
                    paddingLeft: _vm.parameters.left + "px",
                    fontSize: _vm.parameters.fontSize + "pt",
                  },
                },
                [
                  entry.empty
                    ? _c("div", [
                        _c("div", { style: `height: ${_vm.cellHeight}px` }),
                      ])
                    : _vm._e(),
                  !entry.empty
                    ? _c("div", [
                        _c("div", {
                          class: _vm.companyName.startsWith("Bergsoe")
                            ? "bg-img"
                            : "panya-bg-img",
                        }),
                        _c(
                          "div",
                          {
                            ref: "cellContent",
                            refInFor: true,
                            staticClass: "cell-content",
                          },
                          [
                            _vm.parameters.codeType === "qr"
                              ? _c("div", [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c(
                                      "div",
                                      { staticClass: "my-auto" },
                                      [
                                        _c("qriously", {
                                          attrs: {
                                            value: _vm.getCodeValue(entry),
                                            size: Number(_vm.parameters.qrSize),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "ml-3" }, [
                                      _c("table", { staticClass: "qr-info" }, [
                                        _c(
                                          "tbody",
                                          [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "font-weight-bold",
                                                  style: `font-size: ${_vm.parameters.headerFontSize}pt`,
                                                  attrs: { colspan: "2" },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.companyName)
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _vm.parameters.brandName
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "font-weight-light text-caption",
                                                    },
                                                    [_vm._v("Brand")]
                                                  ),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.parameters.brandName
                                                      )
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                            entry.serial
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "font-weight-light text-caption",
                                                    },
                                                    [_vm._v("Serial")]
                                                  ),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(entry.serial)
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                            entry.label
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "font-weight-light text-caption",
                                                    },
                                                    [_vm._v("Label")]
                                                  ),
                                                  _c("td", [
                                                    _vm._v(_vm._s(entry.label)),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                            _vm._l(
                                              _vm.parameters.optionalFields,
                                              function (field, index) {
                                                return _c(
                                                  "tr",
                                                  { key: index },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "font-weight-light text-caption",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(field.label)
                                                        ),
                                                      ]
                                                    ),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(field.value)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ])
                              : _c("div", [
                                  entry.label
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-center font-weight-bold",
                                          style: `font-size: ${_vm.parameters.headerFontSize}pt`,
                                        },
                                        [_vm._v(_vm._s(entry.label))]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "text-center" },
                                    [
                                      _c("vue-barcode", {
                                        key:
                                          _vm.parameters.barcodeBarWidth +
                                          "-" +
                                          _vm.parameters.qrSize,
                                        attrs: {
                                          tag: "svg",
                                          value: _vm.getCodeValue(entry),
                                          options: {
                                            format: "CODE128",
                                            height:
                                              Number(_vm.parameters.qrSize) / 2,
                                            width: Number(
                                              _vm.parameters.barcodeBarWidth
                                            ),
                                            displayValue: false,
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                            _vm.companyAddress
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ma-0 pa-0 font-weight-light footer-text",
                                    style: `font-size: ${_vm.parameters.footerFontSize}pt;`,
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.companyAddress) +
                                        " Tel: " +
                                        _vm._s(_vm.companyPhone) +
                                        " "
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-caption font-weight-light font-size-small d-print-none",
                                        staticStyle: {
                                          float: "right",
                                          position: "relative",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.entryIndex(entry)))]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }